import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import './forms/discount'

class PaymentBtnComponent {
    
    /**
     * Construct module
     * @param label
    */
    constructor(label) {
        
        /**
         * Price label jQuery element
         * @type object
        */
        this.label = label
        
        //No further action if price is 0
        if (parseFloat(this.label.text()) === 0) {
            return
        }
        
        this.bindEvents()
        
    }
    
    /**
     * Set Discount price
     * @param price
    */
    setDiscountPrice(price) {
        
        //Apply price to label element
        this.label.text(price)
        
    }
    
    /**
     * Bind event listeners
    */
    bindEvents() {

        //Bind Discount price event
        EventBus.subscribe('discount.price', this.setDiscountPrice.bind(this))
      
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const label = jQuery('#checkout-pay .next .price')
    
    if (label.length > 0) {
        new PaymentBtnComponent(label)
    }
    
})

export default PaymentBtnComponent